<template>
	<div v-if="moduleVisibility" class="instream-related-module" v-metric="{module: relMmodule}">		
		<ul>
			<li
				v-for="(item, index) in items"
				:key="item.title"
			>
				<span v-if="item.labelText" class="instream-realted-label">{{item.labelText}}:</span>
				<span v-if="!item.labelText" class="instream-realted-label">{{subTitle}}:</span>
				<a
					v-metric="{link: relMlink}"
					:href="item.href"
				>
					{{ item.text }}
					
				</a>
			</li>
		</ul>

	</div>
</template>

<script>
import ModuleLinks from 'webmd-dynamic-links/index.es6';

export default {
	data() {
		return {
			items: [],
			subTitle:'Related',
			moduleVisibility: true
		};
	},

	components: {
		
	},

	props: {		
		relMmodule: {
			type: String,
			default() {
				return 'related-module';
			},		
		},
		relMlink: {
			type: String,
			default() {
				return '';
			},		
		},
	},
	computed: {
		
	},
	mounted() {
		this.$nextTick(() => {
			// to lazy load
			const dlOptions = {
				module: 16,
				count: 1
			};

			const self = this;
			const observer = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					ModuleLinks.fill(dlOptions).then((links) => {
						if (links) {							
							self.items = self.parseDynamicData(links);
							observer.unobserve(self.$el);
							if(self.items.length == 0){
								self.moduleVisibility = false;
							}
						}
					});
				}
			},
			{ rootMargin: `0px 0px 400px 0px` });

			observer.observe(self.$el);

			// to refresh in the future outside of module
			document.addEventListener('webmd.wdl.refresh', async (event) => {
				if (!event.detail || event.detail === 1) {
					const links = await ModuleLinks.fill(dlOptions);
					if (links) {
						self.items = self.parseDynamicData(links);
						if(self.items.length == 0){
							self.moduleVisibility = false;
						}
					}
				}
			});
		});
	}, 
	methods: {
		parseDynamicData(links) {
			return links.map((l) => ({
				text: l.title,
				href: l.url,
				labelText: l.subtitle
			}));
		},

	},

};
</script>

<style lang="scss">
	@import "./stylesheets/variables";
	@import "./stylesheets/component.scss";
</style>